import React from 'react'

export default function TransactionNavbarIcon(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return <svg viewBox="0 0 71 69" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#747894" {...props}>
    <path d="M49.6755 5.70411L61.3641 17.1124L49.6755 28.5207" strokeWidth="5.63465" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.76624 31.3728V28.5207C8.76624 25.4951 9.99771 22.5933 12.1897 20.4538C14.3818 18.3144 17.3548 17.1124 20.4548 17.1124H61.3648" strokeWidth="5.63465" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20.4548 62.7456L8.76624 51.3373L20.4548 39.929" strokeWidth="5.63465" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M61.3648 37.077V39.9291C61.3648 42.9547 60.1333 45.8565 57.9413 47.996C55.7493 50.1354 52.7762 51.3374 49.6762 51.3374H8.76624" strokeWidth="5.63465" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
}
